<template>
    <div>
        <b-form v-if="item && item.Id">
            <b-row>
                <b-col md="6">
                    <b-form-group label="Hücre Adı">
                        <b-form-input :value="$safe(item, 'CellLocation.CellName')" readonly />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Hücre Kodu">
                        <b-form-input :value="$safe(item, 'CellLocation.CellCode')" readonly />
                    </b-form-group>
                </b-col>
                <b-col md="12">
                    <b-form-group label="Hücre Açıklaması">
                        <b-form-textarea :value="$safe(item, 'CellLocation.Description')" readonly rows="2" />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group label="Stok Kodu">
                        <b-form-input :value="item.StockCode" readonly />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Stok Miktarı">
                        <b-form-input :value="item.Balance" readonly />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group label="Oluşturulma Tarihi">
                        <b-form-input :value="formatDate(item.CreatedTime)" readonly />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Son Güncellenme Tarihi">
                        <b-form-input :value="formatDate(item.UpdatedTime)" readonly />
                    </b-form-group>
                </b-col>

                <b-col md="6">
                    <b-form-group label="Bakiye Kayıt ID">
                        <b-form-input :value="item.Id" readonly />
                    </b-form-group>
                </b-col>
                <b-col md="6">
                    <b-form-group label="Hücre ID">
                        <b-form-input :value="item.CellLocationId" readonly />
                    </b-form-group>
                </b-col>
            </b-row>
        </b-form>
        <div v-else class="text-center">Detay bilgisi yüklenemedi.</div>
    </div>
</template>

<script>
import { BForm, BRow, BCol, BFormGroup, BFormInput, BFormTextarea } from "bootstrap-vue";

export default {
    name: "CellBalanceDetailView",
    components: {
        BForm,
        BRow,
        BCol,
        BFormGroup,
        BFormInput,
        BFormTextarea,
    },
    props: {
        item: {
            type: Object,
            default: () => ({}),
        },
    },
    methods: {
        formatDate(dateString) {
            if (!dateString) return "-";
            const options = { year: "numeric", month: "long", day: "numeric", hour: "2-digit", minute: "2-digit" };
            return new Date(dateString).toLocaleDateString("tr-TR", options);
        },
    },
};
</script>
